import confetti from 'canvas-confetti'

/** Corallo, oro, bianco e indaco: gli stessi colori dell'interfaccia. */
const COLORS = ['#ff5a6e', '#ff5a6e', '#e3b75c', '#ffffff', '#5b5bd6']

const prefersReducedMotion = (): boolean => window.matchMedia('(prefers-reduced-motion: reduce)').matches

/** Una raffica di coriandoli da due lati in basso verso il centro; niente con "riduci movimento". */
export function fireConfetti(): void {
  if (prefersReducedMotion()) return
  const base = { particleCount: 70, spread: 70, startVelocity: 55, ticks: 220, colors: COLORS, disableForReducedMotion: true }
  void confetti({ ...base, angle: 60, origin: { x: 0, y: 0.9 } })
  void confetti({ ...base, angle: 120, origin: { x: 1, y: 0.9 } })
}

/** Coriandoli che partono dal punto in cui si è cliccato (coordinate della finestra). */
export function fireConfettiAt(clientX: number, clientY: number): void {
  if (prefersReducedMotion()) return
  void confetti({
    particleCount: 90,
    spread: 100,
    startVelocity: 40,
    ticks: 200,
    colors: COLORS,
    disableForReducedMotion: true,
    origin: { x: clientX / window.innerWidth, y: clientY / window.innerHeight },
  })
}
